// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__12TFq","icon":"styles_icon__2Hxf1"};